
import { Link } from 'react-router-dom';
import { CustomerModel } from '../models/CustomerModel';
import styles from './CustomersPage.module.css';
import React, { useEffect, useState } from 'react';
import customerService from '../services/customerService';
import { formatDate } from '../utils/dateUtils';
import PaginationComp from '../components/PaginationComp';

const CustomersPage = () => {
    const [customers, setCustomers] = useState<CustomerModel[]>([]);
    const pageSize = 10;
    const [keywords, setKeywords] = useState('');
    const [pageNum, setPageNum] = useState(0);
    const [totalCustomers, setTotalCustomers] = useState(0);

    const [isLoading, setIsLoading] = useState(true);
    const [serviceError, setServiceError] = useState('');

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            searchCustomers();
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [pageNum, keywords]);

    const searchCustomers = async () => {
        setIsLoading(true);
        try {
            const response: { customers: CustomerModel[], customerCount: number } = await customerService.searchCustomers(pageNum * pageSize, pageSize, keywords);
            setCustomers(response.customers);
            setTotalCustomers(response.customerCount);
        } catch (error) {
            setServiceError('Failed to load data. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    }

    const changePage = (newPageNum: number) => {
        setPageNum(newPageNum);
    };

    return (
        <div className='mt-3'>
            <div className='row mb-5'>
                <div className='col-12'>
                    <div className="card rounded-0">
                        <div className="card-body p-4">
                            <h5>Customers</h5>
                            <div className="mt-4 mb-1">
                                <div className="input-group">
                                    <span className={`input-group-text ${styles.customerSearchIcon}`}>
                                        <i className="bi bi-search"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control ${styles.customerSearchInput}`}
                                        placeholder="Search by keywords"
                                        aria-label="Search items"
                                        aria-describedby="search-items"
                                        value={keywords}
                                        onChange={(e) => setKeywords(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {serviceError && <div className="col-md-12 mt-3 clearfix"><div className="alert alert-danger p-2 mb-0">{serviceError}</div></div>}
                <div className="col-md-12 mt-3">
                    {isLoading && (
                        <div className="text-center gap-2 mt-3 text-secondary">
                            <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                            <span>  Searching...</span>
                        </div>
                    )}
                    {/* Empty results */}
                    {!isLoading && customers.length === 0 && (
                        (keywords !== '') ? (
                            <div className="border fs-4 mt-4 p-5 text-center">
                                <i className="bi bi-stars clearfix"></i>
                                <span className='clearfix'>No Customer found.</span>
                                <span>Try different keywords</span>
                            </div>
                        ) : (
                            <div className="border fs-4 mt-4 p-5 text-center">
                                <i className="bi bi-stars clearfix"></i>
                                <span className='clearfix'>There are currently no customers.</span>
                            </div>
                        )
                    )}
                    {/* Customer list */}
                    {!isLoading && customers.map(customer => (
                        <div key={customer.sellerCustomerId} className="card mb-3 rounded-0 p-4">
                            <div className="row">
                                <div className={`col-md-12`}>
                                    <h6 className="card-title fs-5 mb-1 one-line-text-ellipsis">{customer.firstname + ' ' + customer.lastname}</h6>
                                    <p className="card-text mb-1">{customer.companyName || '-'}</p>
                                    <p className={`card-text text-muted  mt-auto mb-0 ${styles.customerNotes || '-'}`}>
                                        {customer.notes}
                                    </p>
                                    <p className="card-text text-muted mb-1">Last offer at {formatDate(customer.lastOfferAt)}</p>
                                    <div className="col-md-12 text-end">
                                        <Link to={`/customers/view/${customer.sellerCustomerId}`} state={{ customer }} className="btn btn-sm btn-outline-dark rounded-0" style={{ minWidth: '80px' }}>View</Link>
                                    </div>
                                </div>
                                {serviceError && <div className="col-md-12 clearfix"><div className="alert alert-danger p-2 mb-0">{serviceError}</div></div>}
                            </div>
                        </div>
                    ))}
                </div>
                {/* pagination */}
                {!isLoading && customers.length > 0 && (
                    <PaginationComp pageNum={pageNum} pageSize={pageSize} totalCount={totalCustomers} onPageChange={changePage} />
                )}
            </div>
        </div>
    );
}
export default CustomersPage;